// source: followAssetsMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.FollowAssetsPbMsg', null, global)
goog.exportSymbol('proto.FollowAssetsPbMsg.Assets', null, global)
goog.exportSymbol('proto.FollowAssetsPbMsg.CurrencyAssets', null, global)
goog.exportSymbol('proto.FollowAssetsPbMsg.LeaderCurrencyAssets', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowAssetsPbMsg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FollowAssetsPbMsg.repeatedFields_, null)
}
goog.inherits(proto.FollowAssetsPbMsg, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowAssetsPbMsg.displayName = 'proto.FollowAssetsPbMsg'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.FollowAssetsPbMsg.LeaderCurrencyAssets, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowAssetsPbMsg.LeaderCurrencyAssets.displayName = 'proto.FollowAssetsPbMsg.LeaderCurrencyAssets'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowAssetsPbMsg.Assets = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FollowAssetsPbMsg.Assets.repeatedFields_, null)
}
goog.inherits(proto.FollowAssetsPbMsg.Assets, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowAssetsPbMsg.Assets.displayName = 'proto.FollowAssetsPbMsg.Assets'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FollowAssetsPbMsg.CurrencyAssets = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.FollowAssetsPbMsg.CurrencyAssets, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FollowAssetsPbMsg.CurrencyAssets.displayName = 'proto.FollowAssetsPbMsg.CurrencyAssets'
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FollowAssetsPbMsg.repeatedFields_ = [8]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowAssetsPbMsg.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowAssetsPbMsg.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowAssetsPbMsg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowAssetsPbMsg.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        followtotalaccountrights: jspb.Message.getFieldWithDefault(msg, 1, ''),
        followtotalavailablevalue: jspb.Message.getFieldWithDefault(msg, 2, ''),
        followtotalcnyaccountrights: jspb.Message.getFieldWithDefault(msg, 3, ''),
        followtotalrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 4, ''),
        followtotaltransferinvalue: jspb.Message.getFieldWithDefault(msg, 5, ''),
        followtotalunrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 6, ''),
        userid: jspb.Message.getFieldWithDefault(msg, 7, 0),
        dataList: jspb.Message.toObjectList(
          msg.getDataList(),
          proto.FollowAssetsPbMsg.LeaderCurrencyAssets.toObject,
          includeInstance
        ),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowAssetsPbMsg}
 */
proto.FollowAssetsPbMsg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowAssetsPbMsg()
  return proto.FollowAssetsPbMsg.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowAssetsPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowAssetsPbMsg}
 */
proto.FollowAssetsPbMsg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotalaccountrights(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotalavailablevalue(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotalcnyaccountrights(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotalrealizedsurplusvalue(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotaltransferinvalue(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setFollowtotalunrealizedsurplusvalue(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setUserid(value)
        break
      case 8:
        var value = new proto.FollowAssetsPbMsg.LeaderCurrencyAssets()
        reader.readMessage(value, proto.FollowAssetsPbMsg.LeaderCurrencyAssets.deserializeBinaryFromReader)
        msg.addData(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowAssetsPbMsg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowAssetsPbMsg.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowAssetsPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowAssetsPbMsg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getFollowtotalaccountrights()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getFollowtotalavailablevalue()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getFollowtotalcnyaccountrights()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getFollowtotalrealizedsurplusvalue()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getFollowtotaltransferinvalue()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getFollowtotalunrealizedsurplusvalue()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getUserid()
  if (f !== 0) {
    writer.writeInt64(7, f)
  }
  f = message.getDataList()
  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.FollowAssetsPbMsg.LeaderCurrencyAssets.serializeBinaryToWriter)
  }
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowAssetsPbMsg.LeaderCurrencyAssets.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowAssetsPbMsg.LeaderCurrencyAssets.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        leadernickname: jspb.Message.getFieldWithDefault(msg, 1, ''),
        leaderphoto: jspb.Message.getFieldWithDefault(msg, 2, ''),
        leaderuserid: jspb.Message.getFieldWithDefault(msg, 3, ''),
        tradedate: jspb.Message.getFieldWithDefault(msg, 4, 0),
        leadernftphoto: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
        items: (f = msg.getItems()) && proto.FollowAssetsPbMsg.Assets.toObject(includeInstance, f),
        copytraderid: jspb.Message.getFieldWithDefault(msg, 7, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowAssetsPbMsg.LeaderCurrencyAssets()
  return proto.FollowAssetsPbMsg.LeaderCurrencyAssets.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setLeadernickname(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setLeaderphoto(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setLeaderuserid(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTradedate(value)
        break
      case 5:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setLeadernftphoto(value)
        break
      case 6:
        var value = new proto.FollowAssetsPbMsg.Assets()
        reader.readMessage(value, proto.FollowAssetsPbMsg.Assets.deserializeBinaryFromReader)
        msg.setItems(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCopytraderid(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowAssetsPbMsg.LeaderCurrencyAssets.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getLeadernickname()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getLeaderphoto()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getLeaderuserid()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getTradedate()
  if (f !== 0) {
    writer.writeInt64(4, f)
  }
  f = message.getLeadernftphoto()
  if (f) {
    writer.writeBool(5, f)
  }
  f = message.getItems()
  if (f != null) {
    writer.writeMessage(6, f, proto.FollowAssetsPbMsg.Assets.serializeBinaryToWriter)
  }
  f = message.getCopytraderid()
  if (f !== 0) {
    writer.writeInt64(7, f)
  }
}

/**
 * optional string leaderNickName = 1;
 * @return {string}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getLeadernickname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setLeadernickname = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string leaderPhoto = 2;
 * @return {string}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getLeaderphoto = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setLeaderphoto = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string leaderUserId = 3;
 * @return {string}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getLeaderuserid = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setLeaderuserid = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional int64 tradeDate = 4;
 * @return {number}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getTradedate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setTradedate = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value)
}

/**
 * optional bool leaderNftPhoto = 5;
 * @return {boolean}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getLeadernftphoto = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false))
}

/**
 * @param {boolean} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setLeadernftphoto = function (value) {
  return jspb.Message.setProto3BooleanField(this, 5, value)
}

/**
 * optional Assets items = 6;
 * @return {?proto.FollowAssetsPbMsg.Assets}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getItems = function () {
  return /** @type{?proto.FollowAssetsPbMsg.Assets} */ (
    jspb.Message.getWrapperField(this, proto.FollowAssetsPbMsg.Assets, 6)
  )
}

/**
 * @param {?proto.FollowAssetsPbMsg.Assets|undefined} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setItems = function (value) {
  return jspb.Message.setWrapperField(this, 6, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.clearItems = function () {
  return this.setItems(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.hasItems = function () {
  return jspb.Message.getField(this, 6) != null
}

/**
 * optional int64 copyTraderId = 7;
 * @return {number}
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.getCopytraderid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.LeaderCurrencyAssets.prototype.setCopytraderid = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FollowAssetsPbMsg.Assets.repeatedFields_ = [7]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowAssetsPbMsg.Assets.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowAssetsPbMsg.Assets.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowAssetsPbMsg.Assets} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowAssetsPbMsg.Assets.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        totalaccountrights: jspb.Message.getFieldWithDefault(msg, 1, ''),
        totalcnyaccountrights: jspb.Message.getFieldWithDefault(msg, 2, ''),
        totalunrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 3, ''),
        totalrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 4, ''),
        totaltransferinvalue: jspb.Message.getFieldWithDefault(msg, 5, ''),
        totalavailablevalue: jspb.Message.getFieldWithDefault(msg, 6, ''),
        dataList: jspb.Message.toObjectList(
          msg.getDataList(),
          proto.FollowAssetsPbMsg.CurrencyAssets.toObject,
          includeInstance
        ),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowAssetsPbMsg.Assets}
 */
proto.FollowAssetsPbMsg.Assets.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowAssetsPbMsg.Assets()
  return proto.FollowAssetsPbMsg.Assets.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowAssetsPbMsg.Assets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowAssetsPbMsg.Assets}
 */
proto.FollowAssetsPbMsg.Assets.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalaccountrights(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalcnyaccountrights(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalunrealizedsurplusvalue(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalrealizedsurplusvalue(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotaltransferinvalue(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalavailablevalue(value)
        break
      case 7:
        var value = new proto.FollowAssetsPbMsg.CurrencyAssets()
        reader.readMessage(value, proto.FollowAssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader)
        msg.addData(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowAssetsPbMsg.Assets.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowAssetsPbMsg.Assets.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowAssetsPbMsg.Assets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowAssetsPbMsg.Assets.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getTotalaccountrights()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getTotalcnyaccountrights()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getTotalunrealizedsurplusvalue()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getTotalrealizedsurplusvalue()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getTotaltransferinvalue()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getTotalavailablevalue()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getDataList()
  if (f.length > 0) {
    writer.writeRepeatedMessage(7, f, proto.FollowAssetsPbMsg.CurrencyAssets.serializeBinaryToWriter)
  }
}

/**
 * optional string totalAccountRights = 1;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotalaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotalaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string totalCnyAccountRights = 2;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotalcnyaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotalcnyaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string totalUnRealizedSurplusValue = 3;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotalunrealizedsurplusvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotalunrealizedsurplusvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string totalRealizedSurplusValue = 4;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotalrealizedsurplusvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotalrealizedsurplusvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string totalTransferInValue = 5;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotaltransferinvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotaltransferinvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string totalAvailableValue = 6;
 * @return {string}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getTotalavailablevalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setTotalavailablevalue = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * repeated CurrencyAssets data = 7;
 * @return {!Array<!proto.FollowAssetsPbMsg.CurrencyAssets>}
 */
proto.FollowAssetsPbMsg.Assets.prototype.getDataList = function () {
  return /** @type{!Array<!proto.FollowAssetsPbMsg.CurrencyAssets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FollowAssetsPbMsg.CurrencyAssets, 7)
  )
}

/**
 * @param {!Array<!proto.FollowAssetsPbMsg.CurrencyAssets>} value
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.setDataList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value)
}

/**
 * @param {!proto.FollowAssetsPbMsg.CurrencyAssets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets}
 */
proto.FollowAssetsPbMsg.Assets.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.FollowAssetsPbMsg.CurrencyAssets, opt_index)
}

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FollowAssetsPbMsg.Assets} returns this
 */
proto.FollowAssetsPbMsg.Assets.prototype.clearDataList = function () {
  return this.setDataList([])
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.FollowAssetsPbMsg.CurrencyAssets.prototype.toObject = function (opt_includeInstance) {
    return proto.FollowAssetsPbMsg.CurrencyAssets.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.FollowAssetsPbMsg.CurrencyAssets} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.FollowAssetsPbMsg.CurrencyAssets.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        cnprice: jspb.Message.getFieldWithDefault(msg, 1, ''),
        applogo: jspb.Message.getFieldWithDefault(msg, 2, ''),
        fee: jspb.Message.getFieldWithDefault(msg, 3, ''),
        orderfee: jspb.Message.getFieldWithDefault(msg, 4, ''),
        realavailablebalance: jspb.Message.getFieldWithDefault(msg, 5, ''),
        realizedsurplus: jspb.Message.getFieldWithDefault(msg, 6, ''),
        type: jspb.Message.getFieldWithDefault(msg, 7, 0),
        availablebalance: jspb.Message.getFieldWithDefault(msg, 8, ''),
        positionaccountrights: jspb.Message.getFieldWithDefault(msg, 9, ''),
        maintenancemargin: jspb.Message.getFieldWithDefault(msg, 10, ''),
        price: jspb.Message.getFieldWithDefault(msg, 12, ''),
        realpositionaccountrights: jspb.Message.getFieldWithDefault(msg, 13, ''),
        unrealizedsurplusbtcvalue: jspb.Message.getFieldWithDefault(msg, 14, ''),
        unrealizedsurplusvalue: jspb.Message.getFieldWithDefault(msg, 15, ''),
        accountrightsvalue: jspb.Message.getFieldWithDefault(msg, 16, ''),
        openmargin: jspb.Message.getFieldWithDefault(msg, 17, ''),
        frozenbalance: jspb.Message.getFieldWithDefault(msg, 18, ''),
        sort: jspb.Message.getFieldWithDefault(msg, 19, 0),
        env: jspb.Message.getFieldWithDefault(msg, 20, 0),
        accountrightsbtcvalue: jspb.Message.getFieldWithDefault(msg, 21, ''),
        accountrightscnvalue: jspb.Message.getFieldWithDefault(msg, 22, ''),
        decimalplaces: jspb.Message.getFieldWithDefault(msg, 23, 0),
        currentordermargin: jspb.Message.getFieldWithDefault(msg, 24, ''),
        weblogo: jspb.Message.getFieldWithDefault(msg, 25, ''),
        unrealizedsurplus: jspb.Message.getFieldWithDefault(msg, 26, ''),
        ordermargin: jspb.Message.getFieldWithDefault(msg, 27, ''),
        positionmargin: jspb.Message.getFieldWithDefault(msg, 28, ''),
        contractcode: jspb.Message.getFieldWithDefault(msg, 29, ''),
        currencycode: jspb.Message.getFieldWithDefault(msg, 30, ''),
        availablemargin: jspb.Message.getFieldWithDefault(msg, 31, ''),
        btcvalue: jspb.Message.getFieldWithDefault(msg, 32, ''),
        currencycodedisplayname: jspb.Message.getFieldWithDefault(msg, 33, ''),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.FollowAssetsPbMsg.CurrencyAssets()
  return proto.FollowAssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FollowAssetsPbMsg.CurrencyAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setCnprice(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setApplogo(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setFee(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrderfee(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setRealavailablebalance(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setRealizedsurplus(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setType(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setAvailablebalance(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setPositionaccountrights(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaintenancemargin(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setPrice(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setRealpositionaccountrights(value)
        break
      case 14:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnrealizedsurplusbtcvalue(value)
        break
      case 15:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnrealizedsurplusvalue(value)
        break
      case 16:
        var value = /** @type {string} */ (reader.readString())
        msg.setAccountrightsvalue(value)
        break
      case 17:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenmargin(value)
        break
      case 18:
        var value = /** @type {string} */ (reader.readString())
        msg.setFrozenbalance(value)
        break
      case 19:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSort(value)
        break
      case 20:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setEnv(value)
        break
      case 21:
        var value = /** @type {string} */ (reader.readString())
        msg.setAccountrightsbtcvalue(value)
        break
      case 22:
        var value = /** @type {string} */ (reader.readString())
        msg.setAccountrightscnvalue(value)
        break
      case 23:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDecimalplaces(value)
        break
      case 24:
        var value = /** @type {string} */ (reader.readString())
        msg.setCurrentordermargin(value)
        break
      case 25:
        var value = /** @type {string} */ (reader.readString())
        msg.setWeblogo(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnrealizedsurplus(value)
        break
      case 27:
        var value = /** @type {string} */ (reader.readString())
        msg.setOrdermargin(value)
        break
      case 28:
        var value = /** @type {string} */ (reader.readString())
        msg.setPositionmargin(value)
        break
      case 29:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcode(value)
        break
      case 30:
        var value = /** @type {string} */ (reader.readString())
        msg.setCurrencycode(value)
        break
      case 31:
        var value = /** @type {string} */ (reader.readString())
        msg.setAvailablemargin(value)
        break
      case 32:
        var value = /** @type {string} */ (reader.readString())
        msg.setBtcvalue(value)
        break
      case 33:
        var value = /** @type {string} */ (reader.readString())
        msg.setCurrencycodedisplayname(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.FollowAssetsPbMsg.CurrencyAssets.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FollowAssetsPbMsg.CurrencyAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FollowAssetsPbMsg.CurrencyAssets.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getCnprice()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getApplogo()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getFee()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getOrderfee()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getRealavailablebalance()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getRealizedsurplus()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getType()
  if (f !== 0) {
    writer.writeInt32(7, f)
  }
  f = message.getAvailablebalance()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getPositionaccountrights()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getMaintenancemargin()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
  f = message.getPrice()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getRealpositionaccountrights()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getUnrealizedsurplusbtcvalue()
  if (f.length > 0) {
    writer.writeString(14, f)
  }
  f = message.getUnrealizedsurplusvalue()
  if (f.length > 0) {
    writer.writeString(15, f)
  }
  f = message.getAccountrightsvalue()
  if (f.length > 0) {
    writer.writeString(16, f)
  }
  f = message.getOpenmargin()
  if (f.length > 0) {
    writer.writeString(17, f)
  }
  f = message.getFrozenbalance()
  if (f.length > 0) {
    writer.writeString(18, f)
  }
  f = message.getSort()
  if (f !== 0) {
    writer.writeInt32(19, f)
  }
  f = message.getEnv()
  if (f !== 0) {
    writer.writeInt32(20, f)
  }
  f = message.getAccountrightsbtcvalue()
  if (f.length > 0) {
    writer.writeString(21, f)
  }
  f = message.getAccountrightscnvalue()
  if (f.length > 0) {
    writer.writeString(22, f)
  }
  f = message.getDecimalplaces()
  if (f !== 0) {
    writer.writeInt32(23, f)
  }
  f = message.getCurrentordermargin()
  if (f.length > 0) {
    writer.writeString(24, f)
  }
  f = message.getWeblogo()
  if (f.length > 0) {
    writer.writeString(25, f)
  }
  f = message.getUnrealizedsurplus()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getOrdermargin()
  if (f.length > 0) {
    writer.writeString(27, f)
  }
  f = message.getPositionmargin()
  if (f.length > 0) {
    writer.writeString(28, f)
  }
  f = message.getContractcode()
  if (f.length > 0) {
    writer.writeString(29, f)
  }
  f = message.getCurrencycode()
  if (f.length > 0) {
    writer.writeString(30, f)
  }
  f = message.getAvailablemargin()
  if (f.length > 0) {
    writer.writeString(31, f)
  }
  f = message.getBtcvalue()
  if (f.length > 0) {
    writer.writeString(32, f)
  }
  f = message.getCurrencycodedisplayname()
  if (f.length > 0) {
    writer.writeString(33, f)
  }
}

/**
 * optional string cnPrice = 1;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getCnprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setCnprice = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string appLogo = 2;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getApplogo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setApplogo = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string fee = 3;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getFee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setFee = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string orderFee = 4;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getOrderfee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setOrderfee = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string realAvailableBalance = 5;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getRealavailablebalance = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setRealavailablebalance = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string realizedSurplus = 6;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getRealizedsurplus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setRealizedsurplus = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional int32 type = 7;
 * @return {number}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setType = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * optional string availableBalance = 8;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getAvailablebalance = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setAvailablebalance = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string positionAccountRights = 9;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getPositionaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setPositionaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional string maintenanceMargin = 10;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getMaintenancemargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setMaintenancemargin = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional string price = 12;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string realPositionAccountRights = 13;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getRealpositionaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setRealpositionaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional string unRealizedSurplusBtcValue = 14;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplusbtcvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplusbtcvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value)
}

/**
 * optional string unRealizedSurplusValue = 15;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplusvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplusvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value)
}

/**
 * optional string accountRightsValue = 16;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getAccountrightsvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setAccountrightsvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value)
}

/**
 * optional string openMargin = 17;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getOpenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setOpenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value)
}

/**
 * optional string frozenBalance = 18;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getFrozenbalance = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setFrozenbalance = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value)
}

/**
 * optional int32 sort = 19;
 * @return {number}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getSort = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setSort = function (value) {
  return jspb.Message.setProto3IntField(this, 19, value)
}

/**
 * optional int32 env = 20;
 * @return {number}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getEnv = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setEnv = function (value) {
  return jspb.Message.setProto3IntField(this, 20, value)
}

/**
 * optional string accountRightsBtcValue = 21;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getAccountrightsbtcvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setAccountrightsbtcvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value)
}

/**
 * optional string accountRightsCnValue = 22;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getAccountrightscnvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setAccountrightscnvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value)
}

/**
 * optional int32 decimalPlaces = 23;
 * @return {number}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getDecimalplaces = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setDecimalplaces = function (value) {
  return jspb.Message.setProto3IntField(this, 23, value)
}

/**
 * optional string currentOrderMargin = 24;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getCurrentordermargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setCurrentordermargin = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value)
}

/**
 * optional string webLogo = 25;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getWeblogo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setWeblogo = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value)
}

/**
 * optional string unRealizedSurplus = 26;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getUnrealizedsurplus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setUnrealizedsurplus = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional string orderMargin = 27;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getOrdermargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setOrdermargin = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value)
}

/**
 * optional string positionMargin = 28;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getPositionmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setPositionmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 28, value)
}

/**
 * optional string contractCode = 29;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getContractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setContractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 29, value)
}

/**
 * optional string currencyCode = 30;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getCurrencycode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setCurrencycode = function (value) {
  return jspb.Message.setProto3StringField(this, 30, value)
}

/**
 * optional string availableMargin = 31;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getAvailablemargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setAvailablemargin = function (value) {
  return jspb.Message.setProto3StringField(this, 31, value)
}

/**
 * optional string btcValue = 32;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getBtcvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setBtcvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 32, value)
}

/**
 * optional string currencyCodeDisplayName = 33;
 * @return {string}
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.getCurrencycodedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg.CurrencyAssets} returns this
 */
proto.FollowAssetsPbMsg.CurrencyAssets.prototype.setCurrencycodedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 33, value)
}

/**
 * optional string followTotalAccountRights = 1;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotalaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotalaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional string followTotalAvailableValue = 2;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotalavailablevalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotalavailablevalue = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string followTotalCnyAccountRights = 3;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotalcnyaccountrights = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotalcnyaccountrights = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string followTotalRealizedSurplusValue = 4;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotalrealizedsurplusvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotalrealizedsurplusvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string followTotalTransferInValue = 5;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotaltransferinvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotaltransferinvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string followTotalUnRealizedSurplusValue = 6;
 * @return {string}
 */
proto.FollowAssetsPbMsg.prototype.getFollowtotalunrealizedsurplusvalue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setFollowtotalunrealizedsurplusvalue = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional int64 userId = 7;
 * @return {number}
 */
proto.FollowAssetsPbMsg.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setUserid = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * repeated LeaderCurrencyAssets data = 8;
 * @return {!Array<!proto.FollowAssetsPbMsg.LeaderCurrencyAssets>}
 */
proto.FollowAssetsPbMsg.prototype.getDataList = function () {
  return /** @type{!Array<!proto.FollowAssetsPbMsg.LeaderCurrencyAssets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FollowAssetsPbMsg.LeaderCurrencyAssets, 8)
  )
}

/**
 * @param {!Array<!proto.FollowAssetsPbMsg.LeaderCurrencyAssets>} value
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.setDataList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value)
}

/**
 * @param {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FollowAssetsPbMsg.LeaderCurrencyAssets}
 */
proto.FollowAssetsPbMsg.prototype.addData = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    8,
    opt_value,
    proto.FollowAssetsPbMsg.LeaderCurrencyAssets,
    opt_index
  )
}

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FollowAssetsPbMsg} returns this
 */
proto.FollowAssetsPbMsg.prototype.clearDataList = function () {
  return this.setDataList([])
}

goog.object.extend(exports, proto)
